import { useState, useEffect } from 'react';
import type { CategorySlug } from '../types';
import { storage } from '@shared/utils';

interface UseCategoryResult {
  activeCategory: CategorySlug;
  setActiveCategory: (category: CategorySlug) => void;
}

export function useCategory(): UseCategoryResult {
  const [activeCategory, setActiveCategoryState] = useState<CategorySlug>(() =>
    storage.getPreferredCategory()
  );

  const setActiveCategory = (category: CategorySlug) => {
    setActiveCategoryState(category);
    storage.setPreferredCategory(category);
  };

  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'todays-news-preferred-category' && e.newValue) {
        setActiveCategoryState(e.newValue);
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  return {
    activeCategory,
    setActiveCategory,
  };
}
